import { gql } from "@apollo/client";

export const JOB_POST_DETAILS_QUERY = gql`
  query jobPost($jobPostId: ID!) {
    jobPost(id: $jobPostId) {
      id
      name
      createdAt
      updatedAt
      facility {
        id
        name
        mainAddress {
          address1
          address2
          city
          state
          postalCode
          countryCode
        }
      }
      section {
        id
        name
      }
      currentCompensation
      previousCompensation
      numberOfApplicants
      priority
      status
      subject
      name
      agreedToTermsOfService
      serviceLevel
      compensation {
        baseMaximum
        baseMinimum
        totalAnticipated
        currencyUnit
      }
      benefits
      additionalIncome
      pointOfContact {
        name
        email
        title
        phone
      }
      owner {
        id
        email
        name
        photo
      }
      owners {
        id
        email
        name
        photo
      }
      employer {
        name
        email
        phone
      }
      essentialResponsibilities
      category {
        name
        area
        type
      }
      overview
      pgaOrgUrl
      requiredEducation
      requiredExperienceInYears
      requiredExperienceDescription
      hideCompensationFromJobBoard
      applicantGroup
      applyVia
      paySchedule
      positionType
      stage
      optInToCareerConsultantAssistance
      otherSections
      otherStates
      submissionDeadline
      additionalPgaEducation: additionalPgaEducation
      externalJobUrl
      stopCaseCloseNotifications
      consultantVisitedFacility
      isFacilityConversion
      isPlacementConversion
      isNetNewPosition
      hiredCompensationAmount
      hiredCompensationSchedule
      closeComments
      sendEmployerSurvey
      applicationForm {
        id
        isFormLocked
        questions {
          id
          questionType
          content
          position
          options {
            id
            content
            position
          }
        }
      }
    }
  }
`;
